import { render } from "./UnknownStats.vue?vue&type=template&id=05580acb&scoped=true&ts=true"
import script from "./UnknownStats.vue?vue&type=script&lang=ts"
export * from "./UnknownStats.vue?vue&type=script&lang=ts"

import "./UnknownStats.vue?vue&type=style&index=0&id=05580acb&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05580acb"]])

export default __exports__